export const paymentModeOptions = [
  { key: 'Cash', value: 'Cash', text: 'Cash' },
  { key: 'UPI', value: 'UPI', text: 'UPI' },
  {
    key: 'Credit/Debit Card',
    value: 'Credit/Debit Card',
    text: 'Credit/Debit Card',
  },
  {
    key: 'Internet Banking',
    value: 'Internet Banking',
    text: 'Internet Banking',
  },
];
